export enum REMITTANCE_STEPS {
  searching,
  confirm,
  codeEntry,
  summary,
  notFound,
}

export interface SelectOption {
  id: string | number;
  value: string;
}

export interface BeneficiarySearchResult {
  found: boolean;
  beneficiary: {
    documentNumber: string;
    complement?: string | null;
  };
}

export interface RemittanceParametersData {
  originFunds?: SelectOption[];
  destinationFunds?: SelectOption[];
  transactionReason?: SelectOption[];
  occupation?: SelectOption[];
  relationBetweenRemitBenef?: SelectOption[];
}

export interface BeneficiaryData {
  full_name: string;
  document: string;
  complement: string;
  country: string;
  documentType: string;
  source_income: string | null;
  request_id: number | null;
  person_number: number;
}

export interface SummaryDataInterface {
  fundsOrigin: string;
  fundsDestination: string;
}

export interface RemittanceFormInterface {
  documentNumber: string;
  complement?: string | null;
}

export interface RemittanceData {
  requestid: number;
  status: number;
  creationdatetime: string;
  beneficiary_name: string;
  beneficiary_email?: string | null;
  beneficiary_phone: string;
  beneficiary_document: string;
  beneficiary_typedocument: string;
  beneficiary_complement: string;
  beneficiary_address: string;
  remitter: string;
  origin: string;
  sender: string;
  amount: number;
  currency: string;
  sender_date: string;
  required_pcc01: number;
  source_income: string | null;
}
